var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2 4.8H5.8v10.4h8.4V4.8ZM5 4v12h10V4H5Zm7.2 2.8H7.8v.4h4.4v-.4ZM7 6v2h6V6H7Zm1.5 3h-1v1h1V9Zm-1 2h1v1h-1v-1Zm1 2.011h-1v1h1v-1ZM11.5 9h1v1h-1V9Zm-1 0h-1v1h1V9Zm-1 2.011h1v1h-1v-1Zm1 2h-1v1h1v-1Zm1-2h1v1h-1v-1Zm1 2h-1v1h1v-1Z",
    fill: "currentColor"
  })));
};
export default SvgCalculator;